







import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import { TaskContent } from "../../Classes/Entities/Chat/TaskContent";
import { ThreadRepository } from "../../Classes/Infrastractures/ThreadRepository";
import firebase, { firestore } from 'firebase';


@Component
export default class NoteThreadForm extends Vue {
  @Prop() 
  public taskContent!:TaskContent;
  @Prop() 
  public functionId!: string;

  public _contents!: string;

  public get contents() {
    return this._contents;
  }
  public set contents(contents:string) {
    this._contents = contents;
  }

  public onClick() {
    const threadRepository = ThreadRepository.getInstanceById(this.taskContent.id);
    const uid: string = firebase.auth().currentUser!.uid;
    if (threadRepository != null)
    threadRepository.save({
      contents: this._contents,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      user_id: uid,
      username: 'dummy'
    })
  }
}
